<div class="wallet-container" [formGroup]="balanceForm">
    <h2 class="wallet-title">Add balance to wallet</h2>

    <div class="form-group">
        <label for="amount">Enter amount</label>
        <input id="amount" type="number" class="form-control" formControlName="amount" placeholder="Enter amount" />
    </div>
    <div class="slider-box">
        <div class="slider-wrapper">
            <input type="range" [min]="0" [max]="rangeArray.length - 1" [value]="balanceForm.get('rangeIndex')?.value"
                (input)="onSliderInput($event)" class="custom-slider" #slider>
            <div class="slider-selector" [style.left.px]="indicatorPosition > 0 ? indicatorPosition : 35">
                <div class="slider-select-value">{{ selectedAmount }}</div>
            </div>
            <div class="slider-progress-bar" [style.width.px]="progressBarWidth"></div>
        </div>

        <p class="slider-info">(Total no. of Sp, Sa and Customers)</p>

        <!-- Suggested Amount Section -->
        <span class="suggested-amount">Suggested Amount</span>
        <div class="suggested-container">
            <div class="suggested-box">
                <span class="amount-text">${{ suggestedAmount }}</span>
                <div class="divider"></div>
                <i class="pi pi-clone icon-right" (click)="copySuggestedAmount()" title="Copy amount to field"></i>
            </div>
            <span class="or-text">Or</span>
            <button class="apply-btn" (click)="applySuggestedAmount()">Apply</button>
        </div>
    </div>

    <div class="button-container">
        <button class="cancel-btn" type="button">Cancel</button>
        <button class="add-balance-btn btn-primary" type="button" (click)="onSubmit()">
            <i class="pi pi-plus" style="vertical-align: middle;"></i>
            <span style="margin-left: 8px;" >Add balance</span>
        </button>
    </div>
</div>